import React, { forwardRef, memo, useContext } from 'react';
import VizContext from './VizContext';
import VizSVGAxis, { Props as VizSVGAxisProps } from './VizSVGAxis';

export interface Props extends Omit<VizSVGAxisProps, 'scale'> {}

/**
 * The axis component to be rendered along the x axis, including the
 * axis line, tick lines and labels according to the xDomain given on
 * the Viz component.
 */
export const VizSVGAxisX = forwardRef<SVGGElement, Props>((props: Props, ref) => {
  const {
    xDomain,
    xScale,
  } = useContext(VizContext);

  const {
    x0 = xDomain[0],
    x1 = xDomain[xDomain.length - 1],
    ...rest
  } = props;

  return (
    <VizSVGAxis { ...rest }
        ref={ ref }
        scale={ xScale }
        x0={ x0 }
        x1={ x1 } />
  );
});

export default memo(VizSVGAxisX);
